export default {
  name: 'Название',
  state: 'Наличие',
  description: 'Коментарий'
}
